module.exports = __webpack_public_path__ + "img/bus.3424fb0d.svg";